import { Component, OnInit ,ViewChild,ElementRef} from "@angular/core";
import { FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import json from "../../assets/survey.json";
import {Renderer2} from '@angular/core'
import { QuizService } from '../../Service/Quizservice';
import { ActivatedRoute, Router, UrlSerializer } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import CryptoJS from 'crypto-js';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { findLocaleData } from '@angular/common/src/i18n/locale_data_api';
import { Multerfileupload } from './Multerfileupload.component';
import { $ } from 'protractor';
import swal from 'sweetalert';
import {SafePipe} from './Directive/Safe.pipe'
import * as SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
import CKEDITOR from '@ckeditor/ckeditor5-build-classic';
import * as MathType from '@wiris/mathtype-ckeditor5';

@Component({
  selector: "creator-page",
  templateUrl: "./creator.page.html",
  styleUrls: ["../app.component.css"],
})
export class CreatorPage {

  finalchiddata=[];
  AssignmentForm: FormGroup;
  range;
  editdata;
  assignmentid;
  teachername;
  Astitle;
  Asscore;
  filesize;
  filetype;
  filecount;
  Astaskname;
  Astasktype;
  Asdiscription;
  discntr = true;
  Ckedit;
  Lrnresponse;
  images: any = [];
  allfiles: any = [];
  @ViewChild(Multerfileupload) child;
  uplodedfiles:any =[];
  url;
  editorData: string='';
// public Editor = ClassicEditor;
  ngAfterViewInit() {
   
  }


  ngOnInit() {
    this.getUploadLink();
    ClassicEditor.create(document.getElementById('myDiv')).then(editor => {
      const formControl = document.getElementById('myDiv') as HTMLInputElement;
      const divElement = document.getElementById('demoDiv');

      // Update the form control value when the editor content changes
      editor.model.document.on('change', () => {
        formControl.value = editor.getData();
        formControl.dispatchEvent(new Event('input'));
      });

      // Override the createUploadAdapter method
      editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
        return {
          upload: function () {
            return loader.file
              .then(file => new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('image', file);
                // Replace this URL with your own server endpoint
                const uploadUrl = localStorage.getItem('uploadUrl'); //Change here to localhost link

                const xhr = new XMLHttpRequest();
                xhr.open('POST', uploadUrl, true);
                xhr.setRequestHeader('X-CSRF-TOKEN', 'CSRF-Token-Value'); // Set the CSRF token if required
                xhr.setRequestHeader('Authorization', 'Bearer Token'); // Set the authorization header if required

                xhr.onload = function () {
                  if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);

                    // Get the URL of the uploaded image from the response
                    const imageUrl = `assets/Uploads/${file.name}`;
                    
                    // Create a new image element
                    const imgElement = document.createElement('img');
                    imgElement.src = imageUrl;
                    resolve({
                      default: imageUrl
                    });
                    alert("Image Added Successfully!!!!");
                  } else {
                    reject('Upload failed');
                  }
                };

                xhr.onerror = function () {
                  reject('Upload failed');
                };

                xhr.send(formData);
              }));
          }
        };
      };
    }).catch(error => {
      console.error(error);
    });


    // let blob: any;
    // blob = new Blob(['']);
    // blob.name = 'Screenshot (3).png';
    // blob.lastModifiedDate = new Date();
    // blob.progress = 100;
    // blob.isUploaded = true;
    // blob.isReady = true;
    // blob.isSuccess = true;
    // this.child.uploader.addToQueue([blob]);
   

    this.AssignmentForm = this.formBuilder.group({
      Astitle: ['', Validators.required],
      Lrnresponse: ['', Validators.required],
      Asscore: ['', Validators.required],
      fsize: ['', Validators.required],
      ftype: ['',Validators.required],
      fcount: ['', Validators.required],
      ckedit: ['', Validators.required],
    });
    this.AssignmentForm.controls['fsize'].disable();
    this.AssignmentForm.controls['fcount'].disable();
    this.AssignmentForm.controls['ftype'].disable();

    this.teachername = sessionStorage.getItem('teachername');
    if (this.teachername == undefined) {
      this.logout();
    }
    else {
      this.route.queryParams.subscribe(params => {
        this.assignmentid = (params["Aid"]);
      });
      if (this.assignmentid == undefined) {
        this.editdata = { "pages": [{ "name": "Page1", "title": "Quiz Name", "description": "Quiz Description" }] };

      }
      else {
        this.editdata = JSON.parse(sessionStorage.getItem("editdata"));
        this.filldata(this.editdata);
        this.onSelectionChanged(this.editdata.Learningresponse);
      }
    }
    document.getElementById("btnGroupDrop1").innerText = this.teachername;
  }
  public checkError = (controlName: string, errorName: string) => {
    //console.log(this.AssignmentForm.controls['Astitle'].hasError(errorName) + errorName);
    return this.AssignmentForm.controls[controlName].hasError(errorName);
  }
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private QuizService: QuizService, private _snackBar: MatSnackBar, private formBuilder: FormBuilder,private el :ElementRef) {
    this.getconfigkey().subscribe(data=>{
      this.url=data['resourseurl']//resourseurl
    
  })
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
  }

public getconfigkey():any{            
return this.http.get("assets/env.json");            
}
  iframeurlset(fileitem)
  {
    // (<HTMLIFrameElement>document.getElementById('ifrm')).src = "http://localhost/assignmentresourse/"+fileitem.filename;
    alert(this.url+fileitem.filename);
    console.log(this.url);
    window.open(this.url + fileitem.filename);
  }
   resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }
  filldata(obj) {
    if(obj.Filesize != null)
    {
    this.filesize =  obj.Filesize.split('$')[0];
    this.filetype = obj.Filesize.split('$')[1];
    this.filecount = obj.filecount;
    }
    else
    {
      this.filesize =  "-";
      this.filetype = "-";
      this.filecount = '-';
    }
    this.AssignmentForm.patchValue({
      Astitle: obj.AssignmentTitle,
      Lrnresponse: obj.Learningresponse,
      Asscore: obj.Score,
      fsize: this.filesize,
      ckedit: obj.Description,
      fcount: obj.filecount,
      ftype: this.filetype
    });
    this.uplodedfiles =obj.resourcesinfo;
   //var path = obj.resourcesinfo[0].path
    //sessionStorage.setItem("editresourseurl",path.substring(path.lastIndexOf("\\"),0));

    // this.child.uploader.addToQueue([new File([new Blob([''])], 'emptyTestFile')]);
  //   for(var i in obj.resourcesinfo){
  //     var fileItems = [];

  //     this.child.uploader.addToQueue = new this.child.uploader.FileItem(this.child.uploader, {
  //         dateModified: obj.Createddate,
  //         size: obj.resourcesinfo[i].size,
  //         type: obj.resourcesinfo[i].mimetype,
  //         name: obj.resourcesinfo[i].filename
  //     });

  //     fileItems[i].progress = 100;
  //     fileItems[i].isUploaded = true;
  //     fileItems[i].isReady = true;
  //     fileItems[i].isSuccess = true;

      //  this.child.uploader.queue.push(file)
      //  this.child.uploader.onAfterAddingFile(file);
  // }
  // let file = new File([], obj.resourcesinfo[0].filename, {type: "text/plain", lastModified: obj.Createddate});
  // // let fileItem = new this.child.uploader(this.child.uploader, file, {});
  
  // //(Visual Only) adds the new fileItem to the upload queue
  // this.child.uploader.queue.push(file);
  }
  fd = new FormData();
  fileupload(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      this.fd.append("file" + i, event.target.files[i]);
    }
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = {
          name: '',
          type: '',
          size: '',
          url: ''
        };
        this.allfiles.push(files[i]);
        file.name = files[i].name;
        file.type = files[i].type;
        file.size = files[i].size;
        const reader = new FileReader();
        reader.onload = (filedata) => {
          file.url = reader.result + '';
          this.images.push(file);
        };
        reader.readAsDataURL(files[i]);
      }
    }

  }
  reser() {
    if (this.assignmentid != undefined)
    {
  return  this.router.navigate(['/Assignmentlist'])
  }
    this.AssignmentForm.reset();
    this.onSelectionChanged("reset");
 
     this.child.uploader.clearQueue();
  // swal("Error!","","error");
  }
  onSelectionChanged(selvalu) {
    if (selvalu == "Plain Text" || selvalu =="reset" ) {

      this.AssignmentForm.controls['fsize'].disable();
      this.AssignmentForm.controls['fcount'].disable();
      this.AssignmentForm.controls['ftype'].disable();
      this.AssignmentForm.controls['fsize'].setValue(null);
      this.AssignmentForm.controls['fcount'].setValue('');
      this.AssignmentForm.controls['ftype'].setValue('');
    }
    else {
      if (selvalu == "Single File") {
        this.AssignmentForm.controls['fcount'].setValue('1');
        this.AssignmentForm.controls['fcount'].disable();

        this.AssignmentForm.controls['ftype'].enable();
        this.AssignmentForm.controls['fsize'].enable();
      }
      else {
        this.AssignmentForm.controls['ftype'].enable();
        this.AssignmentForm.controls['fsize'].enable();
        this.AssignmentForm.controls['fcount'].enable();
      }
    }


  }
  // onSurveySaved(survey) {
  //   console.log(survey)
  //   this.json = survey;
  //   const headers = new HttpHeaders()
  //   .set('Authorization', 'my-auth-token')
  //   .set('Content-Type', 'application/json');
  //   var jsonstr=JSON.parse(JSON.stringify(this.json));
  //   if(this.assignmentid==undefined){

  //   jsonstr["teacherid"]=sessionStorage.getItem("Td");
  //     console.log(JSON.stringify(jsonstr))
  //     this.QuizService.addjsondata(JSON.stringify(jsonstr))
  //     .subscribe(data => {
  //       this.Navigateedit(JSON.parse(JSON.stringify(data))['status']) 
  //     });
  //   }
  //   else{
  //     var updatejson={
  //       quizid:CryptoJS.AES.decrypt(this.assignmentid.trim(), 'q').toString(CryptoJS.enc.Utf8),
  //       json:this.json
  //     }
  //     var sts=this.QuizService.updatejsondata(JSON.stringify(updatejson))
  //     .subscribe(data => this.Navigateedit(JSON.parse(JSON.stringify(data))['status']));
  //     console.log(sts=>console.log(sts));
  //   }
  // }
  async getUploadLink() {
    var uploadUrl = await this.http.get('assets/env.json');
    uploadUrl.subscribe(data => { localStorage.setItem('uploadUrl', data['uploadurl']) });
  }
  Navigateedit(obj) {
    if (obj == "S001") {
      var snackBarRef;
      if (this.assignmentid == undefined) {
        snackBarRef = this._snackBar.open("Assignment created successfully", "Ok", {
        });
      }
      else {
        snackBarRef = this._snackBar.open("Assignment updated successfully", "Ok", {
        });
      }
      this.editdata = { "pages": [{ "name": "Page1", "title": "Quiz Name", "description": "Quiz Description" }] };
      snackBarRef.onAction().subscribe(() => {
        this.router.navigate(['/Assignmentlist'])
      });

    }
  }
  uploadfiles() {
    this.QuizService.uploadfiles(this.fd)
      .subscribe(data => {
        this.Navigateedit(JSON.parse(JSON.stringify(data))['status'])
      });
  };
  deleteresourse(delteobj)
  {
    delteobj.assignmentid = this.editdata.id;
    this.QuizService.deleteresourse(JSON.stringify(delteobj))
    .subscribe(data => {  
      if(data['status'] == "f001")
      {
      var snackBarRef=this._snackBar.open("Resource deleted successfully", "Ok", {
      });
      snackBarRef.onAction().subscribe(() => {
          document.getElementById("cancelbtn").click();
      });
      var index = this.uplodedfiles.indexOf(delteobj);
      if (index > -1) {
        this.uplodedfiles.splice(index, 1);
      }
    }
    else
    {
      var snackBarRef=this._snackBar.open("Resource delete unsuccessfull", "Ok", {
      });
      snackBarRef.onAction().subscribe(() => {
          document.getElementById("cancelbtn").click();
      });

    }

    });
  }
  Saveassignment() {
    var jsonobj;
    if (!this.AssignmentForm.valid) {
      for (const key of Object.keys(this.AssignmentForm.controls)) {
        if (this.AssignmentForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          console.log(invalidControl);
          invalidControl.focus();
          break;
       }
      }
      this.AssignmentForm.updateValueAndValidity();
      return;
    }
    // this.child.message.forEach(element => {
    //   var arr=[]
    //   arr["filename"]=element["filename"];
    //   arr["filepath"]=element["path"];
    //   arr["filesize"]=element["size"];
    //   this.finalchiddata.push(arr);
    // });
    if(this.AssignmentForm.get('fsize').value != null)
this.filesize = this.AssignmentForm.get('fsize').value + "$" + this.AssignmentForm.get('ftype').value;
else
this.filesize = null;
    var datetime = new Date().toLocaleString();
    jsonobj  = 
      {
        "Asgtitle": this.AssignmentForm.get('Astitle').value,
        "Score": this.AssignmentForm.get('Asscore').value,
        "Filesize": this.filesize,
        "Learningresponse": this.AssignmentForm.get('Lrnresponse').value,
        "Description": this.AssignmentForm.get('ckedit').value,
        "filecount": this.AssignmentForm.get('fcount').value,
        "createdby": sessionStorage.getItem("Td"),
        "Createddate": datetime,
        "resourcesinfo":this.child.message
      };
    if(this.assignmentid == undefined)
    {
    this.QuizService.Saveassignment(JSON.stringify(jsonobj))
      .subscribe(data => {
        this.Navigateedit(JSON.parse(JSON.stringify(data))['status'])
      });
    }
    else
    {
      for(var fl=0;fl<this.child.message.length;fl++)
      {
      this.uplodedfiles.push(this.child.message[fl]);
      }
      jsonobj["resourcesinfo"] = this.uplodedfiles;
      jsonobj["id"] = this.editdata.id;
      this.QuizService.updatejsondata(JSON.stringify(jsonobj))
      .subscribe(data => {
        this.Navigateedit(JSON.parse(JSON.stringify(data))['status'])
      });
    }

  }
  logout() {
    this.router.navigate(["/"]);
    sessionStorage.clear();
  }

  
  public onKeydownscore(e): any {
             if(!((e.keyCode > 95 && e.keyCode < 106)
             || (e.keyCode > 47 && e.keyCode < 58) 
             || e.keyCode == 8)) {
               return false;
           }

 }
}


